import { render, staticRenderFns } from "./TicketDiscrepancies.vue?vue&type=template&id=4c231d84&"
import script from "./TicketDiscrepancies.vue?vue&type=script&lang=js&"
export * from "./TicketDiscrepancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports